export const getFileExtension = (fileName: string): string =>
    fileName.slice(fileName.lastIndexOf('.') + 1).toLowerCase();

export const blobToBase64 = (blob: Blob): Promise<string> =>
    new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.onloadend = () => {
            resolve(reader.result as string);
        };

        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
